import { blue10, blue20 } from '../../../colors/blue';
import { gray50, gray60, gray95 } from '../../../colors/gray';
import { neutral60opacity10 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
export var checkbox = {
    '--ag-checkbox-background-color': neutral60opacity10,
    '& .ag-checkbox-input-wrapper': {
        '&:after': {
            border: "".concat(rem(1), " solid ").concat(gray50),
        },
        '&:hover:after': {
            color: gray60,
        },
        '&.ag-checked': {
            '--ag-checkbox-background-color': blue20,
            '&:after': {
                color: gray95,
            },
            '&:hover': {
                '--ag-checkbox-background-color': blue10,
            },
        },
        '&.ag-indeterminate': {
            '&:after': {
                color: blue20,
            },
            '&:hover:after': {
                color: blue10,
            },
        },
    },
};
